import { Button, TextField } from '@mui/material';
import { Formik, Form, Field, useFormikContext } from 'formik';
import * as Yup from 'yup';
import GlobalDialogContent from '../GlobalDialogContent';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { CommitmentAgencyApprovedReject } from '../../../utils/services/project/project';
import { closeDialog } from '../../../redux/reducer/dialogSlice';
import { setModuleRefresh } from '../../../redux/reducer/registration/RefreshSlice';
import { showSnackbar } from '../../../redux/reducer/snackbarSlice';

const validationSchema = Yup.object().shape({
    comments: Yup.string().required('Comments are required'),
});

function DialogFooter({ status }: { status?: string }) {
    const { submitForm } = useFormikContext();
    return (
        <Button
            variant="contained"
            color={status === 'Accept' ? 'success' : "primary"}
            onClick={() => submitForm()}
        >
            {status}
        </Button>
    );
}

export default function AgencyAccept() {
    const { status, payload } = useSelector((state: RootState) => state.dialog);
    const dispatch = useDispatch();

    return (
        <>
            <Formik
                initialValues={{ comments: '' }}
                validationSchema={validationSchema}
                onSubmit={async (values, { setSubmitting }) => {
                    const reqPayload = {
                        request_uuid: payload?.uuid,
                        status: status == 'Accept' ? 'approved' : 'rejected',
                        comment: values.comments
                    };
                    const { code, data, message } = await CommitmentAgencyApprovedReject(reqPayload);
                    if (code === 200) {
                        dispatch(closeDialog());
                        dispatch(setModuleRefresh({ moduleName: 'project_details', refresh: true }));
                        dispatch(showSnackbar({ type: 'success', message: message || 'Status Updated Successfully' }));
                    } else {
                        dispatch(showSnackbar({ type: 'error', message: message }));
                    }
                }}
            >
                {({ errors, touched }) => (
                    <GlobalDialogContent
                        dialogBody={
                            <Form>
                                <TextField
                                    label="Allocated Amount"
                                    value={payload.allocated_amount}
                                    size="small"
                                    fullWidth
                                    sx={{pb:2}}
                                    inputProps={{ readOnly: true }}
                                />
                                <Field
                                    as={TextField}
                                    name="comments"
                                    label="Comments *"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    error={touched.comments && Boolean(errors.comments)}
                                    helperText={touched.comments && errors.comments}
                                />
                            </Form>
                        }
                        dialogFooter={<DialogFooter status={status} />}
                    />
                )}
            </Formik>
        </>
    );
}
